import { Button, Dialog, DialogContent, Icons } from '@commenda/kakashi';

export const CloseCheckoutConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-6 flex flex-col gap-4">
        <div className="w-12 h-12 rounded-md bg-bg-warning flex justify-center items-center">
          <Icons.AlertCircle className="text-utility-warning-700" />
        </div>
        <div>
          <h3 className="txt-lg-bold text-text-primary-900 mb-2">
            Exit checkout
          </h3>
          <p className="txt-small-regular text-text-tertiary">
            Are you sure that you want to exit the checkout page. If you do, you
            will have to add the service again to buy.
          </p>
        </div>
        <div className="flex justify-end gap-2 items-center mt-4">
          <Button onClick={onClose} size="md" variant="secondary">
            Cancel
          </Button>
          <Button onClick={onConfirm} size="md">
            Proceed
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
